import * as React from 'react'
import { connect } from 'react-redux'
import Modal from '../../common/modal'
import LineInput from '../../common/lineinput'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import LineInputV2 from '../../common/lineinputV2'
import DropDownOA from '../../common/dropDownOA'
import { useState, useEffect } from 'react'
import { cancelBookingByAdmin, updateAlertError } from '../../../store/common/common_action'
import { useTranslation } from '../../../i18n/I18nProvider'
import { GAJRAJ, STA_COMPANY_ID } from '../../../helper/companyIdhardcode'

const BookingCancelByAdminUI = (props) => {
  const { translations } = useTranslation()
  const lt = translations?.lrTrackingPopup || {}
  const { lrInfo, lrBookingInfo, userList, updateAlertError, handleConfirmPop, handleCancelBooking, data, consignmentDetails, IsLoggedInUserForOfflineBooking } = { ...props }
  const { IsOffineBooking, LoginBookingCompanyId, DestinationCompanyId, BookingUserId } = consignmentDetails?.[0] || {}
  const { common } = data
  let { loginData, } = { ...common }
  const [selUser, setSelUser] = useState('')
  const [cancelRemark, setCancelRemark] = useState('')
  const validPaymentTypes = ["PAID", "PAID(Manual)", "SELF", "TO_PAY_DDDV", "ToPayDDDV"];

  const isAdminUser = loginData?.IsAdmin || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin
  const isLockCancelCompany = [GAJRAJ, STA_COMPANY_ID].includes(loginData?.intCompanyID)
  const shouldLockCancelByUser = !isAdminUser && isLockCancelCompany

  const isOfflineBookingCancelByDiffCompanyUser =
    LoginBookingCompanyId === 66 &&
    IsLoggedInUserForOfflineBooking === 1 &&
    IsOffineBooking === 1 &&
    LoginBookingCompanyId !== DestinationCompanyId

  const getLoggedInUser = () => {
    const loggedInUser = userList?.find((val) => val?.UserID === loginData?.intUserID)
    return loggedInUser || { UserID: loginData?.intUserID, UserName: loginData?.strUserName }
  }

  useEffect(() => {
    if (isOfflineBookingCancelByDiffCompanyUser && userList?.length && BookingUserId) {
      const selectedUserValue = userList.find((val) => val?.UserID === BookingUserId)
      setSelUser(selectedUserValue || '')
    } else if (shouldLockCancelByUser && loginData?.intUserID) {
      setSelUser(getLoggedInUser())
    }
  }, [isOfflineBookingCancelByDiffCompanyUser, userList, BookingUserId, isAdminUser, loginData?.intUserID])

  const getUserList = () => {
    if (isOfflineBookingCancelByDiffCompanyUser) {
      return userList
    }
    const filteredUsers = userList?.filter((val) => val?.BranchID === lrInfo?.BookingBranchID && val?.IsActive !== 0) || []
    if (shouldLockCancelByUser && loginData?.intUserID) {
      const loggedInUser = getLoggedInUser()
      if (!filteredUsers.some((val) => val?.UserID === loggedInUser?.UserID)) {
        return [...filteredUsers, loggedInUser]
      }
    }
    return filteredUsers
  }

  return (
    <Modal headTxt={lt.bookingCancelTitle || 'Booking Cancel'} width={'40%'} updateModal={() => { props.updateModal() }}>
      <Stack direction="column" sx={{ padding: '15px' }}>
        <div style={{ width: '100%', position: 'relative' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }} ref={props?.inputRef}>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={lt.lrNumber || 'LR Number'} value={lrInfo?.LRNo} disabled />
              </div>
            </Box>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={lt.sourceBranch || 'Source Branch'} value={lrInfo?.BookingBranchName} disabled />
              </div>
            </Box>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={lt.bookedByUser || 'Booked By User'} value={lrBookingInfo?.TransactionByUser} disabled />
              </div>
            </Box>
            <Box
              sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px', }}>
              <DropDownOA
                id={`cancelByUserBtn`}
                label={selUser ? (lt.cancelByUser || 'Cancel By User') : (lt.selectCancelByUser || 'Select Cancel By User')}
                data={getUserList()}
                dataKey={`UserName`}
                idKey={`UserID`}
                defaultvalue={selUser?.UserName || ''}
                onSelect={(obj) => setSelUser(obj)}
                onReset={() => setSelUser('')}
                width='100%'
                disabled={isOfflineBookingCancelByDiffCompanyUser || shouldLockCancelByUser}
              />
            </Box>
            <div id='remark' style={{ width: '100%' }} className={'input--wrapper'}>
              <LineInput type={`text`} name={`vlmtrc_unit_wt`} label={lt.cancelRemark || 'Cancel Remark'} onChange={(e) => { setCancelRemark(e.target.value) }} />
            </div>
            <div style={{ width: '100%', textAlign: 'center', fontWeight: '600' }}>
              <span>{lt.refundAmount || 'REFUND AMOUNT'} : {validPaymentTypes.includes(lrInfo.PaymentType) ? lrInfo.NetAmount : 0}</span>
            </div>
          </div>
        </div>
        <Box sx={{ width: '100%', margin: '12px 0px' }}>
          <Button variant="contained" id="saveVolumetricvol" className="btn btn-primary" sx={{ width: '100%', padding: '10px', letterSpacing: '2px' }}
            onClick={() => {
              if (loginData?.intCompanyID !== 406) {
                handleCancelBooking({ data: { selUser, validPaymentTypes, cancelRemark, lrInfo } })
              } else {
                if (selUser == '' || selUser == ' ') {
                  updateAlertError({ show: true, msg: lt.selectCancelByUserAlert || 'Select Cancel By User', nextId: 'cancelByUserBtn' })
                } else if (cancelRemark === '') {
                  updateAlertError({ show: true, msg: lt.selectRemarkAlert || 'Select Remark', nextId: 'remark' })
                } else {
                  handleConfirmPop({ data: { selUser, validPaymentTypes, cancelRemark, lrInfo } })
                }
              }
            }}
          >{lt.cancelBooking || 'Cancel Booking'}</Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { cancelBookingByAdmin, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(BookingCancelByAdminUI)
